export const ALGOLIA_APP_ID = 'WSGRH40UZZ'
export const ALGOLIA_SEARCH_KEY = 'be4c2008dbb90c57dc09a716a759777d'
export const ALGOLIA_INDEX = 'a16z_posts_local'
export const ALGOLIA_INDEX_BY_DATE = 'a16z_posts_local_date'
export const ALGOLIA_INDEX_BY_TIMESTAMP = 'a16z_posts_local_timestamp'
